import 'isomorphic-fetch';
import { isObject } from './misc';
import { message, Modal } from 'antd';
import bignumJSON from 'utils/bignumJSON';
import FormData from 'form-data';
import { localStorage } from 'utils';
import { apiPrefix } from '../../config';

/* eslint-disable */
const noop = () => {};
/* eslint-disable */

// 是否传空参数值,需要时在 callApi 里加上这个参数即可
let isNeedEmpty = false;

function prepend (prefix, name, separator) {
	if (prefix) {
		if (separator) { return prefix + '.' + name; }

		return prefix + name;
	}
	return name;
}

function flatten (prefix, obj, map) {
	if (!isNeedEmpty && !(obj || obj === 0)) {
		return;
	}
	if (obj !== undefined) {
		if (Array.isArray(obj)) {
			for (let i = 0; i < obj.length; i++) {
				var item = obj[i];
				flatten(prepend(prefix, '[' + i + ']', false), item, map);
			}
		} else if (isObject(obj)) {
			if (obj.__type__ === 'map') {
				for (let key in obj) {
					if (key !== '__type__') { flatten(prepend(prefix, '[' + key + ']', false), obj[key], map); }
				}
			} else if (obj instanceof File) {
				// deal with JS based file load
				map[prefix] = obj;
			} else {
				for (let key in obj) {
					flatten(prepend(prefix, key, true), obj[key], map);
				}
			}
		} else {
			map[prefix] = obj;
		}
	}
}

export function toFlattenMap (obj) {
	let map = {};
	isNeedEmpty = false;
	if (obj.isNeedEmpty) {
		delete obj.isNeedEmpty;
		isNeedEmpty = true;
	}
	flatten(null, obj, map);
	return map;
}

export function composeFetch (service, endpoint, data, headers = {}) {
  const loginToken = localStorage.read('loginToken') || '';
	let fullUrl = service ? service + endpoint : endpoint;

	let method = !!data && !!data.method ? data.method : 'POST';

	if (method === 'POST') {
		let params = new FormData();
		if (!!data && !!data.commandObject) {
			let flattenMap = toFlattenMap(data.commandObject);
			for (let key in flattenMap) {
				params.append(key, flattenMap[key]);
			}
    }
    if(loginToken && service === '/ec'){
      Object.assign(headers, {'X-CSRFToken': loginToken});
    }
	Object.assign(headers, {'X-Context': 'os/15'});
		return ({
			fullUrl,
			fetchData: {
				headers,
				credentials: 'same-origin',
				method,
				body: params
			}
		});
	}
	let params = [];
	if (!!data && !!data.commandObject) {
		let flattenMap = toFlattenMap(data.commandObject);

		let i = 0;
		for (let key in flattenMap) {
			if (i++ === 0) { params.push('?'); } else { params.push('&'); }

			params.push(encodeURIComponent(key) + '=' + encodeURIComponent(flattenMap[key]));
		}

		if (params.length > 0) {
			fullUrl = fullUrl + params.join('');
		}
	}

	return ({
		fullUrl,
		fetchData: {
			credentials: 'same-origin',
			method
		}
	});
}

export function callApi (service) {
	const {
		prefix = apiPrefix,
		api,
		data: commandObject = {},
		method,
		success = noop,
		error,
		defaultError = true,
		complete = noop,
		errorConfirm = false,
		showErrorMsg = true
	} = service;

	const fetchInfo = composeFetch(prefix, api, { commandObject, method });

	return new Promise((resolve, reject) => {
		const fetchPromise = fetch(fetchInfo.fullUrl, fetchInfo.fetchData).then((response) => {
			return response.text().then(text => text);
		}).then((response) => {
      const data = bignumJSON.parse(response);
			if (Number(data.errorCode) === 200) {
        const { responseObject, response } = data;
        let defValue = (responseObject === 0 || response === 0) ? 0 : {};
				defValue = (responseObject === false || response === false) ? false : {};
				resolve(responseObject || response || defValue); // 有的请求成功不一定有responseObject
				success(responseObject || response || defValue);
			} else if (Number(data.errorCode) === 401) {
				window.location.hash = '/login';
			} else if(Number(data.errorCode) === 10001 && data.errorScope === 'authorization') {
        // 权限不足，弹出modal提示去重新登录
        Modal.info({
          className: 'zl-callapi-modal',
          title: '注意',
          content: '您已被禁止使用该店铺的相关功能，请重新选择店铺。',
          okText: '确定',
          onOk: () => {
            window.location.hash = '/dashboard';
          }
        });
      } else {
				reject(data);
				if (error) {
					if (showErrorMsg) {
						if (errorConfirm) {
							Modal.warning({
								title: data.errorDescription,
								okText: '确定'
							});
						} else {
							message.error(data.errorDescription);
						}
					}
					error(data);
				} else if (defaultError) {
					message.error(data.errorDescription || '系统异常，请稍候再试', 1.5);
				}
			}
		}).catch((err) => {
			console.warn(err);
		});

		if (!('finally' in fetchPromise)) {
			fetchPromise.finally = Promise.prototype.finally;
		}

		fetchPromise.finally(() => {
			if (complete) {
				complete();
			}
		});
	});
}

export function callRaw (service, endpoint, data, headers) {
	const fetchInfo = composeFetch(service, endpoint, data, headers);
	return fetch(fetchInfo.fullUrl, fetchInfo.fetchData);
}
